import { action, computed, observable } from 'mobx';
import type { CXRootStore } from '../../stores/cx-root.store';
import {
    IUserConfig,
    IStickyHeaderState,
    ICompanyBrandingData,
    IGenericConfig
} from '../types/client-exprience.types';
import { TContactFormState } from '../../../../types/instant-pay.types';

export class GiftCardCXStore {
    rootStore: CXRootStore = null;

    @observable hbContactFormWrapperState: TContactFormState = 'none';
    @observable cfId: string = null;
    @observable companyBrandingData: ICompanyBrandingData = null;
    @observable genericConfig: IGenericConfig = null;
    @observable hbToken: string = null;
    @observable userConfig: IUserConfig = null;
    @observable stickyHeaderState: IStickyHeaderState = null;

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    @action
    setUserConfig(newConfigValues: IUserConfig) {
        this.userConfig = Object.assign(this.userConfig || {}, newConfigValues);
    }

    @action
    setCompanyBrandingData(newCompanyBrandingData: ICompanyBrandingData) {
        this.companyBrandingData = Object.assign(
            this.companyBrandingData || {},
            newCompanyBrandingData
        );
    }

    @action
    setCfId(cfId: string) {
        this.cfId = cfId;
    }

    @action
    setHbToken(hbToken: string) {
        this.hbToken = hbToken;
    }

    @action
    setGenericConfig(newConfigValues: IGenericConfig) {
        this.genericConfig = Object.assign(
            this.genericConfig || {},
            newConfigValues
        );
    }

    @action
    setHbContactFormState(newState: TContactFormState) {
        this.hbContactFormWrapperState = newState;
    }

    @action
    setStickyHeaderState(newState: IStickyHeaderState) {
        this.stickyHeaderState = newState;
    }

    @computed get contactForm() {
        return this.userConfig && this.cfId
            ? this.userConfig.contact_forms.find(x => x._id === this.cfId)
            : null;
    }

    @computed get isContactFormWrapperReadyForLoad() {
        const {
            giftCardCXStore: {
                userConfig,
                genericConfig,
                hbContactFormWrapperState
            }
        } = this.rootStore;

        const isInactiveMessageDataLoaded =
            (this.contactForm &&
                this.contactForm.contact_form_settings &&
                this.contactForm.contact_form_settings.is_active) ||
            this.companyBrandingData;

        return (
            userConfig &&
            genericConfig &&
            isInactiveMessageDataLoaded &&
            hbContactFormWrapperState === 'mounted'
        );
    }

    @computed get placementId() {
        const {
            clientPortalConfigStore: { configuration }
        } = this.rootStore;

        if (!configuration) {
            return null;
        }
        return configuration.placement_id;
    }
}
